<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="bodymatter">
<span epub:type="pagebreak" id="p36" title="36">
<p class="icon"><span class="grey">[</span> QUICK PREP <span class="grey">]</span></p>
<h2 class="recipetitle" id="impossibly_easy_mini_breakfast_sausage_pies">Impossibly Easy Mini Breakfast Sausage Pies</h2>
<p class="recipetime"><span class="yield_black">6 servings (2 mini pies each)</span> <span class="separater">|</span> Prep Time: 15 Minutes <span class="separater">|</span> Start to Finish: 1 Hour 5 Minutes</p>
<p class="dot">•••</p>
<p class="ingredient_head">SAUSAGE MIXTURE</p>
<ul class="ingredient1">
<li class="list"><span class="qty1">¾</span> lb bulk pork breakfast sausage</li>
<li class="list"><span class="qty1">1</span> medium onion, chopped (½ cup)</li>
<li class="list"><span class="qty1">1</span> can (4 oz) mushrooms pieces and stems, drained</li>
<li class="list"><span class="qty1">½</span> teaspoon salt</li>
<li class="list"><span class="qty1">3</span> tablespoons chopped fresh sage leaves</li>
<li class="list"><span class="qty1">1</span> cup shredded Cheddar cheese (4 oz)</li>
</ul>
<p class="ingredient_head">BAKING MIXTURE</p>
<ul class="ingredient1">
<li class="list"><span class="qty1">½</span> cup Original Bisquick mix</li>
<li class="list"><span class="qty1">½</span> cup milk</li>
<li class="list"><span class="qty1">2</span> eggs</li>
</ul>
<p class="recipeprocedure"><span class="stepnum">1</span> Heat oven to 375°F. Spray 12 regular-size muffin cups with cooking spray.</p>
<p class="recipeprocedure"><span class="stepnum">2</span> In 10-inch skillet, cook sausage and onion over medium-high heat 5 to 7 minutes, stirring occasionally, until sausage is no longer pink; drain. Cool 5 minutes; stir in mushrooms, salt, sage and cheese.</p>
<p class="recipeprocedure"><span class="stepnum">3</span> In medium bowl, stir baking mixture ingredients with whisk or fork until blended. Spoon slightly less than 1 tablespoon baking mixture into each muffin cup. Top each with about ¼ cup sausage mixture and 1 tablespoon baking mixture.</p>
<p class="recipeprocedure"><span class="stepnum">4</span> Bake about 30 minutes or until toothpick inserted in center comes out clean and tops are golden brown. Cool 5 minutes. With thin knife, loosen sides of pies from pan; remove from pan and place top sides up on cooling rack. Cool 10 minutes longer before serving.</p>
<p class="recipeprocedure"><span class="stepnum">5</span> To freeze, cool completely. Wrap tightly. Freeze up to 3 months. Thaw in refrigerator overnight. Unwrap; microwave 1 pie on High about 1 minute or until hot.</p>
<p class="recipe_info"><span class="nutr_bold">1 Serving:</span> Calories 250; Total Fat 17g (Saturated Fat 8g, Trans Fat 0.5g); Cholesterol 105mg; Sodium 920mg; Total Carbohydrate 10g (Dietary Fiber 1g); Protein 14g <span class="nutr_bold">Exchanges:</span> ½ Starch, ½ Vegetable, 1½ High-Fat Meat, 1 Fat <span class="nutr_bold">Carbohydrate Choices:</span> ½</p>
</span></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p036.vue?11449618